<template>
  <div class="h-full">
    <el-select
      ref="multiplePersonSelectComp"
      v-model="values"
      placeholder="请选择"
      class="w-full"
      :multiple="isMultiple"
      clearable
      filterable
      :disabled="disabled"
      collapse-tags
      @change="changePerson"
    >
      <el-option v-for="item in tableData" :key="item.id" :label="item.name" :value="item.id">
        <el-tooltip :content="`${item.name}`">
          <span class="float-left w-100px truncate font-bold">{{ item.name }}</span>
        </el-tooltip>
        <el-tooltip :content="postsInfo(item.orgUnits)">
          <span
            class="float-right w-100px truncate"
            v-if="item.orgUnits && item.orgUnits.length > 0"
            >{{ postsInfo(item.orgUnits) }}</span
          >
        </el-tooltip>
      </el-option>
    </el-select>
  </div>
</template>

<script type="text/babel">
import { EafOrganizationUnitUserApi } from '@wiz-api/account'

const eafOrganizationUnitUserApi = new EafOrganizationUnitUserApi()
export default {
  name: 'multiple-person-select',
  props: {
    personValue: {
      type: String,
      default: ''
    },
    // 是否禁用选择按钮
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      default: '',
    },
    // 是否多选
    isMultiple: {
      type: Boolean,
      default: true,
    },
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  data() {
    return {
      values: null,
      tableData: [],
    }
  },
  computed: {
    postsInfo() {
      return (val) => {
        return _.map(val, (item) => {
          return item.organizationUnitName
        }).join(',')
      }
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (val) {
        this.values = this.isMultiple ? JSON.parse(JSON.stringify(val)).split(',') : val
      } else {
        this.values = this.isMultiple ? [] : ''
      }
      }
    },
  },
  methods: {
    // 获取用户label
    getUserLabel() {
      let names = ''
      if (this.isMultiple) {
        names = _.map(this.$refs.multiplePersonSelectComp.selected, (item) => {
          return item.currentLabel
        }).join(',')
      } else {
        names = this.$refs.multiplePersonSelectComp.selected.currentLabel
      }
      return names
    },
    // 获取用户
    changePerson(values) {
      this.$emit('change', this.isMultiple ? values.join(',') : values)
    },
    // 获取用户列表
    async getUserList() {
      const [err, res] = await eafOrganizationUnitUserApi.getOrganizationUnitUserList({
        organizationUnitId: undefined,
        includeOrgChild: true, // 是否查询该部门子部门人员
        sorting: '',
        maxResultCount: 999, // 每页多少条
        skipCount: 0, // 跳过多少条
      })
      if (!err) {
        this.tableData = res.items
      }
    },
  },
  created() {
    this.getUserList()
  },
}
</script>

<style scoped lang="scss"></style>
